<!--  -->
<template>
  <div class="prview_box">
    <div class="phoner_box">
      <div class="all_boxr">
        <div class="content_box" v-html="content" />
        <div v-for="item,index of attachments" :key="index" class="at_box">
          <div
            v-if="item.msgtype === 'image'"
            class="onebox"
          >

            <img v-if="item.msgtype === 'image' && item.image && item.image.media_id!=='' && item.image.media_id!==null" :src="item.image.pic_url" style="width:80px;height:80px;margin:10px 0px 0px 23px">
          </div>
          <div v-if="item.msgtype === 'link'" class="onebox">
            <div v-if="item.msgtype === 'link' && item.link && item.link.title!==''&& item.link.title!==null" class="within_box">
              <div class="title_boxr">{{ item.link.title }}</div>
              <div class="imaetext se_top">
                <div class="describe_text">{{ item.link.desc }}</div>
                <div>
                  <img v-if="item.link.picurl" style="width:50px;height:50px;object-fit: contain;" :src="item.link.picurl">
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="item.attachments.msgtype === 'miniprogram'" class="onebox">

            <div v-if="item.attachments.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.title!=='' && item.miniprogram.title!==null">
              <div class="mincard">
                <div class="mincard_title">{{ find(item.miniprogram.appid) }}</div>
                <div class="mincard_enjoy">{{ item.miniprogram.title }}</div>
                <div>
                  <img v-if="item.msgtype === 'miniprogram' && item.miniprogram && item.miniprogram.pic_media_src!=='' && item.miniprogram.pic_media_src!==null" :src="item.miniprogram.pic_media_src" class="imgrbox">
                </div>
                <div class="line" />
                <div class="bottomwr">
                  <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                  <div class="weadar">小程序</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.attachments.msgtype === 'sp_miniprogram'" class="onebox">
            <div v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.title!=='' && item.sp_miniprogram.title!==null">
              <div class="mincard">
                <div style="display: flex;align-items: center;"><img :src="item.sp_miniprogram.weappiconurl" style="width: 25px;" alt="" srcset=""><div class="mincard_title" style="margin-bottom: 0px;margin-left:5px">{{ item.sp_miniprogram.des_1 }}</div></div>
                <div class="mincard_enjoy">{{ item.sp_miniprogram.title }}</div>
                <div>
                  <img v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.thumburl!=='' && item.sp_miniprogram.thumburl!==null" :src="item.sp_miniprogram.thumburl" class="imgrbox">
                </div>
                <div class="line" />
                <div class="bottomwr">
                  <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                  <div class="weadar">小程序</div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

      <!-- </div> -->
      </div>
      <!-- <div class="bottomwr" style="margin-bottom:20px">
      <div class="box_serw">标题预览：</div>
      <div>{{ title }}</div>
    </div> -->
      <!-- <div class="bottomwr" style="margin-bottom:20px">
        <div>消息文本：</div>
        <div>{{ content }}</div>
      </div> -->

    </div>
  </div>
</template>

<script>
import { momentsDetail } from '@/api/workWechat.js'
export default {
  components: {},
  data() {
    return {
      attachments: [],
      programtype: [],
      title: '',
      content: '',
      id: ''
    }
  },
  created() {
    // this.$nextTick(() => {
    //   this.send()
    // })
  },
  mounted() {

  },
  methods: {
    send(item) {
      console.log('详情===', item)
      // this.title = item.title
      if (item.content === null) {
        this.content = ''
      } else {
        this.content = item.content.replace(/\n/g, '<br>')
      }
      this.id = item.sp_moments_no
      console.log('详情', item.sp_moments_no)
      this.$nextTick(() => {
        this.getmptypeslist()
      })

      //       const a=
      // [{\"link\": {\"url\": \"https://example.link.com/path\", \"title\": \"消息标题\", \"media_id\": \"WWME_YmkyEQAAlIyM1mHpsJeNbvI4_vLAuA\"}, \"msgtype\": \"link\"}]
    },
    // 获取小程序消息类型
    async getmptypeslist(id) {
      const data = await momentsDetail({ sp_moments_no: this.id })
      // this.programtype = data.data.types
      console.log('xiangqing', data.data.item)
      // this.attachments = Array.from(data.data.item.attachments)
      this.attachments = data.data.item.attachments
      // console.log(typeof (this.attachments))

      // console.log('this.attachments ===', this.attachments)
      // for (const key of this.attachments) {
      //   console.log('obj.' + key + ' = 我是' + this.attachments[key])
      // }
    }
    // find(id) {
    //   console.log('id', id)
    //   const indexs = this.programtype.findIndex(item => {
    //     // eslint-disable-next-line eqeqeq
    //     return item.mini_program_type == id
    //   })
    //   if (indexs === -1) {
    //     return ''
    //   } else {
    //     return this.programtype[indexs].type_name
    //   }
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box{
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 23px;
  margin-top: 15px;
}
.title_boxr{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 157px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard{
  width: 150px;
  height: 200px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 23px;
}
.mincard_title{
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox{
  width: 100%;
  height: 100px;
}
.line{
  width: 100%;
  height: 1px;
  background: #999999;
  margin: 5px 0px;
}
.bottomwr{
  display: flex;
  align-items: center;
}
.mincard_enjoy{
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar{
  margin-left: 2px;
  font-size: 12px;
}
.all_box{
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox{
  display: flex;
  align-items: center;
}
.swr{
  width: 50px;
  text-align: right;
}
.prview_box{
  /* max-height: 500px;
  overflow: hidden;
  overflow-y: scroll; */
}
.prview_box::-webkit-scrollbar {
  width: 0;
}
.box_serw{
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.phoner_box{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    margin:0 auto;
    position: relative;
}
.at_box{
  margin: 10px 0px;
}
.all_boxr{
  max-height: 365px;
  overflow-y: auto;
  position: absolute;
  top: 120px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 92%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ededed;
  border-radius: 5px;
}
.content_box{
  padding: 20px;
}
</style>
